// extracted by mini-css-extract-plugin
module.exports = {"chart_card":"ChartCard_chart_card__MUbpS","chart_card_title":"ChartCard_chart_card_title__15soO","chart_card_content":"ChartCard_chart_card_content__3iQoZ"};